import { render } from "./PoInput.vue?vue&type=template&id=fa8b3702&scoped=true"
import script from "./PoInput.vue?vue&type=script&lang=js"
export * from "./PoInput.vue?vue&type=script&lang=js"

import "./PoInput.vue?vue&type=style&index=0&id=fa8b3702&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa8b3702"]])

export default __exports__